export const messages = {
  en: {
    communitySettingManage: {
      inputPlaceholder: 'Required, please enter {name}',
      settingTips: 'Reminder: No spaces before or after input',
      saveSuccess: 'Save successfully'
    }
  },
  zh: {
    communitySettingManage: {
      inputPlaceholder: '必填，请输入{name}',
      settingTips: '温馨提示：填写前后不要有空格',
      saveSuccess: '保存成功'
    }
  }
}